import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/content";

export const Testimonials = () => {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="bg-[#FAFAFA] py-24 md:py-28"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-14">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-orange-600 mb-4">
            <span>{`{ `}</span>testimonios<span>{` }`}</span>
          </div>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
            Lo que dicen quienes ya confiaron.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, idx) => (
            <figure
              key={idx}
              data-testid={`testimonial-${idx}`}
              className="relative bg-white border border-slate-200 rounded-2xl p-7 md:p-8 hover:shadow-md transition-shadow flex flex-col"
            >
              <Quote className="h-8 w-8 text-orange-500 mb-4" />
              <blockquote className="text-slate-700 text-base md:text-lg leading-relaxed flex-1">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-slate-100">
                <div className="font-display font-bold text-slate-900">{t.author}</div>
                <div className="text-sm text-slate-500 font-mono">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
